module.exports = __webpack_public_path__ + "static/media/1015063.1f7708da.jpg";